"use client";

import { motion } from "framer-motion";
import { Calculator } from "lucide-react";
import Link from "next/link";

export default function CalculatorBanner() {
  return (
    <section className="py-16 sm:py-20 px-6 bg-gradient-to-r from-[#0D0C09] to-[#1a1814] overflow-hidden relative">
      {/* decorative gold blurs */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#B8893A]/10 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#D4A754]/10 rounded-full blur-3xl translate-x-1/2 translate-y-1/2 pointer-events-none" />

      <div className="relative max-w-4xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#B8893A]/20 text-[#B8893A] mx-auto mb-6">
            <Calculator size={32} />
          </div>

          <h2 className="text-3xl md:text-5xl font-black text-white mb-4 tracking-tight leading-tight">
            How Much Does Business Setup
            <span className="block text-[#B8893A]">in Dubai Cost?</span>
          </h2>

          <p className="text-gray-400 text-base max-w-xl mx-auto mb-8 leading-relaxed">
            Your business activity, location, number of visas, and shareholders all play a role. Use our smart calculator for an instant, accurate estimate no commitment required.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/calculator"
              className="px-8 py-3 rounded-xl bg-[#B8893A] text-white font-bold shadow-lg hover:bg-[#A67B34] transition-all hover:scale-105 flex items-center justify-center gap-2 text-sm"
            >
              <Calculator size={18} />
              Calculate Now
            </Link>
            <a
              href="tel:+971586009980"
              className="px-8 py-3 rounded-xl border-2 border-[#B8893A]/50 text-[#B8893A] font-bold hover:border-[#B8893A] hover:bg-[#B8893A]/10 transition-all flex items-center justify-center gap-2 text-sm"
            >
              Talk to a Specialist
              <span className="font-normal">+971 58 600 9980</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
